import axios, { AxiosResponse } from "axios";
import {
  APP_ASSESSMENTS,
  APP_ASSESSMENTS_RESULTS,
  FETCH_ASSESSMENT,
  FETCH_ASSESSMENT_PDF,
  FETCH_ASSESSMENT_SUMMARY,
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_COUNT,
  FETCH_SKILLS,
  FETCH_SKILLS_GROUP,
  FETCH_USER_WITH_PROFILE,
  FETCH_USERS_INFO,
  FETCH_USERS_WITH_NAME_AND_EID,
  GET_JOB_BY_ID,
  GET_ROLES_LIST,
  GET_UNIQUE_SECTORS,
  NOTIFICATIONS_ACTION,
  SEND_EMAIL,
  UPLOAD_FILE_CHUNK
} from "@/store/urls/common";
import {
  AppAssessmentResult,
  FetchNotificationListPayload,
  FetchSkillsGroupActionPayload,
  SendEmailPayload,
  SkillSearchPayload,
  UpdateNotificationStatusPayload
} from "@/store/modules/common/interfaces";

export const get_unique_sectors = async (): Promise<AxiosResponse> => {
  return await axios.get(GET_UNIQUE_SECTORS).then((response) => response.data);
};

export const get_roles_list = async (): Promise<AxiosResponse> => {
  return await axios.get(GET_ROLES_LIST);
};
export const get_job_by_id = async (job_id: number): Promise<AxiosResponse> => {
  return await axios.get(`${GET_JOB_BY_ID}${job_id}`);
};

export const fetch_skills_group = async (
  payload: FetchSkillsGroupActionPayload
): Promise<AxiosResponse> => {
  return await axios.post(FETCH_SKILLS_GROUP, payload);
};

export const fetch_skills = async (
  payload: SkillSearchPayload
): Promise<AxiosResponse> => {
  return await axios.post(FETCH_SKILLS, payload);
};

export const fetch_user_info = async (name: string): Promise<AxiosResponse> => {
  return await axios.get(`${FETCH_USERS_INFO}${name}`);
};

export const fetch_user_with_profile = async (
  uid: number
): Promise<AxiosResponse> => {
  return await axios.get(`${FETCH_USER_WITH_PROFILE}${uid}`);
};

export const get_notifications_count = async (): Promise<AxiosResponse> => {
  return await axios.get(FETCH_NOTIFICATIONS_COUNT);
};

export const get_notifications_list = async (
  payload: FetchNotificationListPayload
): Promise<AxiosResponse> => {
  const page = payload.page;
  const limit = payload.limit;
  let query = `?page=${page}&limit=${limit}&`;
  if (payload.is_read) query += `is_read=${payload.is_read}`;
  return await axios.get(`${FETCH_NOTIFICATIONS}${query}`);
};

export const update_notifications_status = async (
  payload: UpdateNotificationStatusPayload
): Promise<AxiosResponse> => {
  return await axios.post(`${NOTIFICATIONS_ACTION}`, payload);
};

export const fetch_assessment_summary = async (
  assessment_id: number
): Promise<AxiosResponse> => {
  return await axios.get(`${FETCH_ASSESSMENT_SUMMARY}${assessment_id}`);
};

export const fetch_assessment_pdf = async (
  assessment_id: number
): Promise<AxiosResponse> => {
  return await axios.get(`${FETCH_ASSESSMENT_PDF}${assessment_id}`);
};

export const fetch_assessment = async (
  user_id: number
): Promise<AxiosResponse> => {
  return await axios.get(`${FETCH_ASSESSMENT}${user_id}`);
};

export const app_assessments = async (): Promise<AxiosResponse> => {
  return await axios.get(`${APP_ASSESSMENTS}`);
};

export const app_assessments_result = async (
  payload: AppAssessmentResult
): Promise<AxiosResponse> => {
  // console.log("Getting result from common.ts: ", payload);
  let query = `${payload.assessment_id}/result/`;
  if (payload.user_id) query += `${payload.user_id}`;
  // const result = await axios.get(`${APP_ASSESSMENTS_RESULTS}${query}`);
  // console.log("Result: ", axios.get(`${APP_ASSESSMENTS_RESULTS}${query}`));
  return await axios.get(`${APP_ASSESSMENTS_RESULTS}${query}`);
  // return result;
};

export const app_assessments_result_pdf = async (
  payload: AppAssessmentResult
): Promise<AxiosResponse> => {
  let query = `${payload.assessment_id}/result/`;
  if (payload.user_id) query += `${payload.user_id}/pdf`;
  // Expect backend to stream the actual PDF binary.
  return await axios.get(`${APP_ASSESSMENTS}${query}`, {
    responseType: "blob"
  });
};

export const send_email = async (
  payload: SendEmailPayload
): Promise<AxiosResponse> => {
  return await axios.post(`${SEND_EMAIL}`, payload);
};

export const upload_file_chunk = async (
  payload: FormData
): Promise<AxiosResponse> => {
  return await axios.post(`${UPLOAD_FILE_CHUNK}`, payload);
};

export const fetch_user_by_name_and_eid = async (
  name: string,
  signal?: AbortSignal
): Promise<AxiosResponse> => {
  return await axios.get(`${FETCH_USERS_WITH_NAME_AND_EID}${name}`, {
    signal
  });
};
